export const fetchJobConfig = {
  endpoint: process.env.JOBS_API_URL,
  params: {
    headers: {
      accept: 'application/json'
    }
  }
};
